


































































































import { defineComponent, PropType, toRefs, computed } from '@vue/composition-api';
import ProductDetails from '../../../components/creative/product-details';
import ImageSettingsEnhancementsCompose from '../image-settings-enhancements/image-settings-enhancements-compose.vue';
import { useImageSettingStore } from '../image-settings-enhancements/hooks';
import {
  AcoFormData,
  CampaignFormData,
  AdgroupFormData,
  FullNormalFormData,
  creativeDomIds,
  PRODUCT_SPECIFIC_TYPE,
  catalogProductFormFields,
  StoreType,
} from '@tt4b/ttam-enums';
import {
  useProductSetStore,
  useStore,
  useCreativeCatalogSelectValidation,
  useStdCampaignIs,
  useAllowlist,
  useStdAdgroupIs,
} from '@tt4b/ttam-hooks';
import { i18n } from './../../../i18n';

const name = 'ttam-ad-detail-catalog-info-compose';
export default defineComponent({
  name,
  components: {
    ImageSettingsEnhancementsCompose,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    // 用于区分汽车广告 VSA不传取默认值StoreType.ECOM
    catalogType: {
      type: Number,
      default: StoreType.ECOM,
    },
    creativeUuid: {
      type: String,
    },
  },
  setup(props) {
    const { campaignData, adgroupData, creativeData, catalogType, creativeUuid } = toRefs(props);
    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value?.aadvid);

    const { isLeadAdsAutoInventoryAds } = useStdCampaignIs({
      campaignFormData: campaignData,
    });

    const { isStandardAdsWithCatalog } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    const headerText = computed(() =>
      isLeadAdsAutoInventoryAds.value
        ? i18n.t('creative_aia_carousel_image_source')
        : i18n.t('module_creative_catalog_carousel_image_source'),
    );

    // AIA与VSA表单字段不同，需要分别获取对应的表单字段
    const formFieldsConfig = computed(() => catalogProductFormFields?.[catalogType.value]);

    const catalogId = computed(() => adgroupData.value?.[formFieldsConfig.value?.CATALOG_ID]);
    // AIA未涉及到该字段 取值字段不适配AIA
    const products = computed(() => creativeData.value.dpaProducts || []);
    const productSpecificType = computed(() => creativeData.value?.[formFieldsConfig.value?.PRODUCT_TYPE]);

    const catalogInfo = ProductDetails.useCatalogInfo({ adgroupData, catalogType });

    const { productSetList } = useProductSetStore({ adgroupFormData: adgroupData, catalogType });

    const catalogAuthorizedBc = adgroupData.value?.[formFieldsConfig.value?.BC_ID];
    const link = computed(
      () => `/catalogs/overview?aadvid=${aadvid.value}&id=${catalogId.value}&bc_id=${catalogAuthorizedBc}`,
    );
    const productName = computed(() => catalogInfo.value.name);

    const productSetId = computed(() => creativeData.value?.[formFieldsConfig.value?.PRODUCT_SET_ID]);

    const pSetName = computed(() => {
      const curProduct = productSetList.value.filter(item => item.id === productSetId.value);
      return curProduct[0]?.name;
    });
    const isProductSet = computed(() => productSpecificType.value === PRODUCT_SPECIFIC_TYPE.PRODUCT_SET);
    const isSelectProduct = computed(() => productSpecificType.value === PRODUCT_SPECIFIC_TYPE.PRODUCTS);
    const showErrorMessage = computed(() => {
      // AIA 目前不限制product数量
      if (isLeadAdsAutoInventoryAds.value) {
        return false;
      }
      if (isSelectProduct.value) {
        return products?.value?.length < 2;
      } else if (isProductSet.value) {
        if (!pSetName.value) {
          return true;
        } else {
          const curPSetList = productSetList.value.filter(catalog => catalog.name === pSetName.value);
          return curPSetList[0]?.prod_approved_count < 2;
        }
      } else {
        return catalogInfo.value.prod_approved_count < 2;
      }
    });
    const handleGotoProduct = () => {
      if (catalogInfo.value.prod_approved_count < 2) {
        window.open(link.value);
      } else {
        document
          .getElementById(creativeDomIds.PRODUCT_DETAILS)
          ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
    const { catalogInfoValidator } = useCreativeCatalogSelectValidation({
      adgroupData,
      creativeData,
      catalogType,
    });

    const { isVSACarouselOptimizedImagesWhite } = useAllowlist();
    const showImageSetting = computed(() => isVSACarouselOptimizedImagesWhite.value && isStandardAdsWithCatalog.value);
    const carouselImageInfo = computed(() => creativeData.value.carouselImageInfo);
    const { getImproveTaskStatus } = useImageSettingStore();
    const isRunning = computed(() => {
      const { loading } = getImproveTaskStatus(creativeUuid.value);
      return loading;
    });

    return {
      name,
      link,
      aadvid,
      pSetName,
      products,
      productName,
      catalogInfo,
      isProductSet,
      isSelectProduct,
      showErrorMessage,
      handleGotoProduct,
      productSpecificType,
      catalogInfoValidator,
      headerText,
      isLeadAdsAutoInventoryAds,
      showImageSetting,
      carouselImageInfo,
      isRunning,
    };
  },
});
